import Loadable from 'react-loadable';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const ForgotPasswordPageContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "ForgotPasswordPageContainer" */
      './ForgotPasswordPageContainer.dynamic'
    ),
  loading: LoadingPageLoadable,
});
